import React, { useMemo, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../../utils/dateUtils';

const ApprovalCommentsTable = ({ data, isLoading = false }) => {
    const { th } = useLanguage();
    const [collapsed, setCollapsed] = useState(true);
    const panelRef = useRef(null);

    const items = useMemo(() => data?.items || [], [data]);

    // Eğer yükleniyor değilse VE hiç item yoksa, component'i gösterme
    if (!isLoading && items.length === 0) return null;

    const commentDateBody = (row) => {
        const dt = row?.commentDate ? new Date(row.commentDate) : null;
        if (!dt || isNaN(dt)) return '-';
        return formatDateOnly(dt);
    };

    const typeBody = (row) => {
        if (!row?.typeName) return '-';
        const key = `warrantyClaims.detail.comments.types.${row.typeName}`;
        const translated = th(key);
        return translated === key ? row.typeName : translated;
    };

    const togglePanel = () => {
        const togglerBtn = panelRef.current?.getElement?.()?.querySelector('.p-panel-header-icon');
        if (togglerBtn) togglerBtn.click();
        else setCollapsed((prev) => !prev);
    };

    const headerTemplate = () => (
        <div className="flex align-items-center justify-content-between w-full">
            <div className="flex align-items-center">
                <i className="pi pi-comments mr-2" style={{ fontSize: '0.9rem' }} />
                <span className="font-semibold">{th('warrantyClaims.detail.comments.title') || 'Comments'}</span>
                <span className="ml-2 text-sm text-gray-600">({items.length})</span>
            </div>
        </div>
    );

    return (
        <div className="col-12 mb-3">
            <Panel
                ref={panelRef}
                header={headerTemplate}
                toggleable
                collapsed={collapsed}
                onToggle={(e) => setCollapsed(e.value)}
                expandIcon="pi pi-chevron-down"
                collapseIcon="pi pi-chevron-up"
                pt={{
                    header: {
                        onClick: togglePanel,
                        style: { cursor: 'pointer', boxShadow: 'none' },
                        tabIndex: 0,
                        onKeyDown: (e) => {
                            if (e.key === 'Enter' || e.key === ' ') togglePanel();
                        }
                    },
                    content: {
                        style: { padding: 0 }
                    }
                }}
            >
                <DataTable
                    value={items}
                    loading={isLoading}
                    size="small"
                    stripedRows
                    showGridlines
                    responsiveLayout="scroll"
                    pt={{
                        wrapper: { style: { border: 'none' } },
                        table: { style: { border: 'none' } }
                    }}
                    scrollable
                    scrollHeight="220px"
                    className="w-full"
                    emptyMessage={th('common.noRecords') || 'No records found'}
                >
                    <Column
                        header={th('warrantyClaims.detail.comments.date') || 'Date'}
                        body={commentDateBody}
                        style={{ width: '140px' }}
                    />
                    <Column
                        field="commentedBy"
                        header={th('warrantyClaims.detail.comments.commentedBy') || 'Commented By'}
                        style={{ width: '220px' }}
                    />
                    <Column
                        header={th('warrantyClaims.detail.comments.type') || 'Type'}
                        body={typeBody}
                        style={{ width: '180px' }}
                    />
                    <Column
                        field="comment"
                        header={th('warrantyClaims.detail.comments.comment') || 'Comment'}
                    />
                </DataTable>
            </Panel>
        </div>
    );
};

export default ApprovalCommentsTable;
